import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

// import { getUser } from '../../utils/Common';
// import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { Icon } from 'semantic-ui-react';
import { getUser } from "../../utils/Common";
import FloatNavigationMeu from "../sharecomponents/FloatNavigationMenu";
import "../../estilos/dashboardStyle.css";


const Navigation = (props) => {
    const [menus, setMenus] = useState([]);
    const [menuNomina, setMenuNomina] = useState(false);
    const [navegar, setnavegar] = useState(false);
    // const [user, setUser] = useState({});

    useEffect(() => {
        //props.logout();
        const user = getUser();
        setMenus([...user.menus]);
        // setUser({...user});
    }, []);


    const handleLogout = () => {
        props.logout();
    };

    const actionMenu = (value, index) => {
        // const index = menus.findIndex(menu => menu.menu_id == m.menu_id);
        let provMenus = menus;
        for (let i = 0; i < provMenus.length; i++) provMenus[i].showMenu = 0;
        if (value == 0) provMenus[index].showMenu = 1;
        setMenus([...provMenus]);
    }

    const onMouseLeave = () => {
        setMenuNomina(false);
    }

    return (
        <>
            <nav id="header" className="shadow contenedor fixed z-10 top-0 m-0 shadow dosis" style={{ width: '100vw', height: '50px' }}>
                <div className='vw-100  showMovil text-center'>
                    <button className='btn btn-sm bw-300 round-xxl btn-light shadow text-m p-0 border border-warning border-2 text-bold'
                        style={{ letterSpacing: '2.5px' }}
                        onClick={() => { setnavegar(!navegar) }}>Navegación</button>
                </div>
                <div className='hideMovil'>
                    <div className="vw-100 flex flex-grow items-center w-auto block pt-2 mt-0 bg-white z-20 " id="nav-content" >
                        <ul className="hidden md:list-reset md:flex md:flex-1 md:items-center md:px-4 pb-1 m-0 " >
                            {/** Dashboard */}
                            <li className="mr-6 my-2 md:my-0">
                                <NavLink className="text-main-color border-orange-900 no-underline" to="/dashboard">
                                    <i className="fas fa-home fa-fw mr-1" />
                                    <span className="pl-2 pb-1 menu-link-text" style={{ fontWeight: 'bold', fontSize: 'medium' }}>Inicio</span>
                                </NavLink>
                            </li>
                            {/** menu generator */}
                            {menus.map((m, i) => {
                                let link;
                                if (+m.tienesm === 1) {
                                    link = <button className="menu-link-text scale-025" onClick={() => actionMenu(m.showMenu, i)} style={{ fontWeight: 'bold' }}>
                                        <i className="fas fa-caret-right fa-fw m-0 p-0" /> {m.nombre}
                                    </button>;
                                } else {
                                    link = <NavLink to={m.url} className="menu-link-text border-orange-900 no-underline scale-025 text-600"> {m.nombre} </NavLink>;
                                }
                                return (
                                    <li className="mr-6 my-2 md:my-0" key={i}>
                                        {link}  {/** menu */}
                                        {+m.showMenu === 1 && +m.tienesm === 1 &&
                                            <div className="absolute mt-3 py-2 bg-white "
                                                onMouseLeave={() => actionMenu(m.showMenu, i)}>
                                                {m.subMenus.map((s, j) => {
                                                    return (
                                                        <NavLink to={s.url} key={j}
                                                            className="block px-4 py-2 text-black dosis navbarsubmnu  no-underline">
                                                            <i className="fas fa-caret-right fa-fw mr-1" /> {s.nombre}
                                                        </NavLink>
                                                    );
                                                })}
                                            </div>
                                        }
                                    </li>
                                );
                            })}

                            {/** Sensores */}
                            <li className="mr-6 my-2 md:my-0 no-underline">
                                <NavLink
                                    className="text-main-color border-orange-900 no-underline"
                                    to="/sensores"
                                >
                                    <span className="pb-1 md:pb-0 text-s no-underline text-600">Datos de Sensores</span>
                                </NavLink>
                            </li>
                            {/** ./Sensores */}
                        </ul>

                        <div className="relative pull-right m-0 p-0 mb-2 contenedor">
                            <button className='btn btn-danger shadow round-xl me-3 scale-025' onClick={handleLogout}> <Icon name="sign-out" /> Salir</button>
                        </div>
                    </div>
                </div>
                {navegar && <FloatNavigationMeu close={() => { setnavegar(false) }} />}
            </nav >
        </>
    );
};

export default Navigation;
